module.exports = __webpack_public_path__ + "media/ק.aa33fc10.mp3";